import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { paragraphLarge } from '@helpers/typography';
import MarketplaceCardStyles from '@stories/Components/Cards/MarketplaceCard/MarketplaceCard.styles';
import FilterTabButtonsStyles from '@stories/Components/Misc/FilterTabButtons/FilterTabButtons.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${FilterTabButtonsStyles.Container} {
    --spacingY: ${fluid(32, 48)};

    z-index: 3;
    margin: 0 0 var(--spacingY);

    @media ${until(Device.TabletLarge)} {
      position: relative !important;
    }

    @media ${from(Device.TabletLarge)} {
      padding-top: var(--spacingY);

      &::before {
        content: '';
        display: block;
        position: absolute;
        height: 1.5px;
        width: 66%;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        background-color: ${brand.grey.light};
      }
    }
  }
`;
const ItemsWrapper = styled.div `
  --rowItems: 1;

  @media ${from(Device.Tablet)} {
    --rowItems: 2;
  }

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: var(--gutterWidth);
  margin: 0 0 ${fluid(32, 40)};
  scroll-margin: var(--headerHeight, 0px) 0 0;

  ${MarketplaceCardStyles.Container} {
    flex: 0 0
      calc(
        100% / var(--rowItems) -
          (var(--gutterWidth, 0px) * ((var(--rowItems) - 1) / var(--rowItems)))
      );
  }

  @media ${from(Device.TabletSmall)} {
    --rowItems: 2;
  }

  @media ${from(Device.DesktopSmall)} {
    --rowItems: 3;
  }
`;
const NoResultsText = styled.p `
  ${paragraphLarge};
`;
const MarketplaceListStyles = {
    Container,
    ItemsWrapper,
    NoResultsText,
};
export default MarketplaceListStyles;
